// 触发保存菜单栏的路径方法
// import api from "../service/api.js";
import api from "../service/api";
import { Message } from 'element-ui';
import FUnitls from '../utils/public.js'
import VueCookies from 'vue-cookies'

export const saveUser = ({ commit }) => {
  commit("setUser", { "currentUser_name": localStorage.getItem("currentUser_name"), "user_token": localStorage.getItem("currentUser_token"), "user_id": localStorage.getItem("currentUser_id"),"user_mail":localStorage.getItem("currentUser_mail"),"user_phone":localStorage.getItem("currentUser_phone") });
};


export const LoginOut = ({ commit }) => {
  commit("LoginOut");
};
export const saveUserMail = ({ commit }, { userId, mail }) => {
  commit("setUserMail", { mail: mail, userId: userId });
};
export const saveUserPhone = ({ commit },  phone ) => {
  commit("setUserPhone",phone);
};
export const saveKeyword = ({ commit }, keywords) => {
  commit("saveKeyword", keywords);
};
export const saveKeywordTime = ({ commit }) => {
  commit("saveKeywordTime");
};


//new Date().getTime();

export const savePath = ({ commit }, payload) => {
  commit('savePath', payload);
};

// 触发获取当前点击的数据源方法
export const saveCurrDbSource = ({ commit }, payload) => {
  commit('saveCurrDbSource', payload);
};

// 触发获取当前点击的元数据方法
export const saveCurrJobData = ({ commit }, payload) => {
  commit('saveCurrJobData', payload);
};

// 触发获取所有数据源方法
export const saveDbSource = ({ commit }, payload) => {
  commit('saveDbSource', payload);
};

// 触发保存搜索后选择单条元数据方法
export const saveSelectJobMeta = ({ commit }, payload) => {
  commit('saveSelectJobMeta', payload);
};

// 触发保存搜索专题数据方法
export const saveSpecialSubject = ({ commit }, payload) => {
  commit('saveSpecialSubject', payload);
};

// 触发保存复制元数据方法
export const saveDuplicateJobMeta = ({ commit }, payload) => {
  commit('saveDuplicateJobMeta', payload);
};

// 获取商品的搜索条件
export const goodsWhere = ({ commit }, info) => {
  commit('saveGoodsWhere', info);
};

// //用户登录
// export const userLogin = ({ commit },{mail,password,router})=>{})

// 用户登陆
export const userLogin = ({ commit }, info) => {
  var loginInfo = {};

  if (info.code == "") {
    loginInfo.type = info.type;
    loginInfo.password = info.password;
    if (info.type == 1) {
      loginInfo.phone = info.username;
    } else {
      loginInfo.mail = info.username;
    }
  } else {
    loginInfo.type = info.type;
    loginInfo.phone = info.username;
    loginInfo.code = info.code;
  }

  api.user.login(loginInfo).then((res) => {
    if (res != null && res.data != undefined && res.data.errno == 0 && res.data.data != undefined && "token" in res.data.data) {
      VueCookies.set("userinfo", res.data.data)
      var token = res.data.data.token;
      if (token != "") {
        commit("setUser", { "user_name": res.data.data.name, "user_token": token, "user_id": res.data.data.id, "user_mail": res.data.data.mail, "user_phone": res.data.data.phone });
        FUnitls.showInfo("登录成功", "success");
      }
    } else {
      if (res.data.errno == 99999) {
        commit("setOnlyUserEmail", { "mail": mail });
        router.push({ name: "usertoactivate" })
      } else {
        var options = {
          message: res.data.errmsg,
        }
        Message.error(options)
      }
    }
  }, (res) => {
    var options = {
      message: "接口错误",
    }
    Message.error(options)
  }
  )
};


// WEBPACK FOOTER //
// ./src/store/actions.js